import { Audio } from "expo-av";
import { useEffect, useState } from "react";

const SOUNDS = {
  clear: require("../assets/sounds/clear.mp3"),
  coin: require("../assets/sounds/coin.mp3"),
  get: require("../assets/sounds/get.mp3"),
  more: require("../assets/sounds/more.wav"),
} as const;

type SoundType = keyof typeof SOUNDS;

type Sounds = Record<SoundType, Audio.Sound>;

export const useSound = () => {
  const [sounds, setSounds] = useState<Sounds>(null);
  const [isReady, setIsReady] = useState(false);

  const _init = async () => {
    try {
      const _sounds: Sounds = {
        clear: new Audio.Sound(),
        coin: new Audio.Sound(),
        get: new Audio.Sound(),
        more: new Audio.Sound(),
      };
      await Promise.all(
        Object.entries(_sounds).map(async ([k, v]) => {
          await v.loadAsync(SOUNDS[k]);
        })
      );
      setSounds(_sounds);
      console.log("Sounds init done.");
    } catch (error) {
      console.error(error);
    }
  };

  const _destroy = async () => {
    try {
      for (const key in sounds) {
        if (sounds.hasOwnProperty(key)) {
          await sounds[key].stopAsync();
          await sounds[key].unloadAsync();
        }
      }
      setSounds(null);
      console.log("Sounds destroy done.");
    } catch (error) {
      console.error(error);
    }
  };

  const play = async (soundType: SoundType) => {
    const _sound = sounds[soundType];
    try {
      await _sound.setPositionAsync(0);
      await _sound.playAsync();
    } catch (error) {
      console.error(error);
    }
  };

  const stop = async (soundType: SoundType) => {
    const _sound = sounds[soundType];
    try {
      await _sound.stopAsync();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      _init();
      setIsReady(true);
    })();
    return () => {
      (async () => {
        await _destroy();
      })();
    };
  }, []);

  return {
    play,
    stop,
    isReady,
  };
};
